// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1lEfD","rootCenter":"LoadMoreObserver_rootCenter__1k-38","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2sdFT"};